import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'icullen-linkify-image',
  templateUrl: './linkify-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./linkify-image.component.css'],
})
export class LinkifyImageComponent implements OnInit {
  @Input() imageSrc: string;
  @Input() class = '';

  constructor() {}

  ngOnInit() {
    if (this.imageSrc == null) {
      throw new Error(`: imageSrc is required, but was not provided`);
    }
  }
}
